var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C11 11.553 10.552 12 9.99998 12C9.44798 12 8.99998 11.553 8.99998 11V1C8.99998 0.447 9.44798 0 9.99998 0C10.552 0 11 0.447 11 1V11ZM13.2389 2.5413C13.4919 2.0503 14.0959 1.8593 14.5859 2.1113C17.9249 3.8383 19.9999 7.2433 19.9999 11.0003C19.9999 16.5133 15.5139 21.0003 9.99988 21.0003C4.48588 21.0003 -0.00012207 16.5133 -0.00012207 11.0003C-0.00012207 7.2433 2.07488 3.8383 5.41488 2.1113C5.90388 1.8583 6.50788 2.0493 6.76188 2.5413C7.01588 3.0313 6.82288 3.6343 6.33288 3.8883C3.65988 5.2693 1.99988 7.9943 1.99988 11.0003C1.99988 15.4113 5.58888 19.0003 9.99988 19.0003C14.4109 19.0003 17.9999 15.4113 17.9999 11.0003C17.9999 7.9943 16.3399 5.2693 13.6679 3.8883C13.1769 3.6343 12.9849 3.0313 13.2389 2.5413Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.98cd9ccffa428a9b70564a554e16f683.svg";
export { ForwardRef as ReactComponent };